<div id="yes-no-modal-container" style="min-width: 500px;">
  <h1 mat-dialog-title>{{headerTitle}}</h1>
  <div mat-dialog-content>
    <p>{{message}}</p>
  </div>
  <div mat-dialog-actions align="end">
    <div class="btn-group" role="group">
      <button mat-raised-button color="accent" (click)="onYesClick()">
        {{yesText}}
      </button>
      @if (!setNoButtonAsDefault) {
        <button mat-raised-button color="secondary" (click)="onNoClick()">
          {{noText}}
        </button>
      }
      @if (setNoButtonAsDefault) {
        <button mat-raised-button color="primary" (click)="onNoClick()" cdkFocusInitial>
          {{noText}}
        </button>
      }
    </div>
  </div>
</div>
